import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white px-6 pt-6 h-screen pb-52 lg:h-[calc[100vh_-_100px]] overflow-y-auto" }
const _hoisted_2 = { class: "custom-full" }
const _hoisted_3 = {
  key: 0,
  class: "bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]"
}
const _hoisted_4 = { class: "mb-3 flex justify-between" }
const _hoisted_5 = {
  key: 1,
  class: "p-3 bg-[#2B2C32] border-0 rounded-lg"
}
const _hoisted_6 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass('w-full hidden-component z-10')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_block_loading = _resolveComponent("block-loading")!
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass('flex content-main gap-5 ' + (_ctx.action.component ? ' half-it' : ''))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Nav),
        (_ctx.loadingBadges)
          ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.loyaltyProgram && _ctx.loyaltyProgram.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "text-[24px] text-white font-semibold" }, "Badges", -1)),
                      (!_ctx.action.component && _ctx.can_edit_membership_details)
                        ? (_openBlock(), _createBlock(_component_mdicon, {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addUpdate({ component: 'Add', data: {} }))),
                            size: "32",
                            name: "plus",
                            class: "text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_List, {
                      selectedCallback: _ctx.selectedItem,
                      clearComponent: _ctx.clearComponent,
                      iscomponentactive: _ctx.action.component ? true : false
                    }, null, 8, ["selectedCallback", "clearComponent", "iscomponentactive"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("div", { class: "mb-3 flex justify-between" }, [
                      _createElementVNode("h3", { class: "text-[20px] text-theme-878686 font-bold tracking-wider" }, "Badges")
                    ], -1),
                    _createElementVNode("p", { class: "text-sm" }, " Loyalty Program is inactive or not set.", -1)
                  ]))]))
            ], 64))
      ]),
      (_ctx.action.component)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.action.component), {
              earningSetting: _ctx.earningSetting,
              loyaltyProgramId: _ctx.loyaltyProgram.id,
              item: _ctx.action.data,
              clearComponent: _ctx.clearComponent
            }, null, 8, ["earningSetting", "loyaltyProgramId", "item", "clearComponent"]))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}